<script setup>
import { FireIcon } from '@heroicons/vue/24/solid'
import { useI18n } from '../../i18n.js'

const { locale, t } = useI18n()

defineProps({ tanks: { type: Array, default: () => [] } })

function liters(value) {
  return value == null ? '—' : `${new Intl.NumberFormat(locale.value, { maximumFractionDigits: 1 }).format(value)} ${t('pts2UiLiters')}`
}

function percent(value) {
  return value == null ? '—' : `${Math.round(value)}%`
}
</script>

<template>
  <div v-if="tanks.length" class="pts2-tank-list">
    <article v-for="(tank, index) in tanks" :key="tank.id" class="pts2-tank-row"
      :class="{ warning: tank.warning }">
      <span class="pts2-tank-number">{{ tank.id }}</span>
      <FireIcon class="pts2-tank-icon" :class="`tone-${index % 4}`" aria-hidden="true" />
      <span class="pts2-tank-product">
        <strong>{{ tank.productName || t('pts2UiProductUnknown') }}</strong>
        <small v-if="tank.warning">{{ t('pts2UiLowLevel') }}</small>
      </span>
      <progress class="pts2-tank-progress" :class="`tone-${index % 4}`"
        :value="tank.fillPercent ?? undefined" max="100"
        :aria-label="tank.fillPercent == null
          ? t('pts2UiTankProgressUnknown', { id: tank.id })
          : t('pts2UiTankProgress', { id: tank.id, percent: Math.round(tank.fillPercent) })">
        {{ percent(tank.fillPercent) }}
      </progress>
      <strong class="pts2-tank-percent" :class="`tone-${index % 4}`">{{ percent(tank.fillPercent) }}</strong>
      <dl class="pts2-tank-values">
        <div><dt>{{ t('pts2UiVolume') }}</dt><dd>{{ liters(tank.volume) }}</dd></div>
        <div><dt>{{ t('pts2UiFreeVolume') }}</dt><dd>{{ liters(tank.freeVolume) }}</dd></div>
      </dl>
    </article>
  </div>
  <p v-else class="pts2-inline-empty">{{ t('pts2UiNoTanks') }}</p>
</template>
